export default "__VITE_ASSET__df79126a__"